// extracted by mini-css-extract-plugin
export default {"modalOverlay":"ModalSurveyQuestion_modalOverlay__U20Eq","surveyQuestionContainer":"ModalSurveyQuestion_surveyQuestionContainer__f7ABs"};